import helpersUrl from './python/helpers.py';
import gameUrl from './python/index.py';
import { customPrint } from './helpers.js';

let pyodide;
let gameRunning = false;

window.onload = async () => {
  // The pyodide package is downloaded via a CDN.
  // eslint-disable-next-line no-undef
  pyodide = await loadPyodide();

  // Load the game code
  runGame();
};

const runGame = async () => {
  if (gameRunning) return;
  gameRunning = true;

  const gameCodeResp = await fetch(gameUrl);
  let gameCode = await gameCodeResp.text();

  // Modify the game code to work with the browser.
  gameCode = gameCode.replace(/input\(\)/g, '(await input())');
  gameCode = gameCode.replace(/def play_game\(\):/g, 'async def play_game():');
  gameCode = gameCode.replace(/def print_slow\(/g, 'def print_slo(');
  gameCode = gameCode.replace(/def clear\(/g, 'def clea(');
  gameCode = gameCode.replace(/def kulrek_wait\(/g, 'def kulrek_wai(');
  gameCode = gameCode.replace(/def txt_speed_option\(/g, 'def txt_speed_optio(');
  gameCode = gameCode.replace(/print_slow\(/g, 'await print_slow(');
  gameCode = gameCode.replace(/kulrek_wait\(/g, 'await kulrek_wait(');
  gameCode = gameCode.replace(/def move_hint\(/g, 'async def move_hin(');
  gameCode = gameCode.replace(/move_hint\(/g, 'await move_hint(');
  gameCode = gameCode.replace(/def move_hin\(/g, 'def move_hint(');
  gameCode = gameCode.replace(/def game_hint\(/g, 'async def game_hin(');
  gameCode = gameCode.replace(/game_hint\(/g, 'await game_hint(');
  gameCode = gameCode.replace(/def game_hin\(/g, 'def game_hint(');
  gameCode = gameCode.replace(/def minigame_rules\(/g, 'async def minigame_rul(');
  gameCode = gameCode.replace(/minigame_rules\(/g, 'await minigame_rules(');
  gameCode = gameCode.replace(/def minigame_rul\(/g, 'def minigame_rules(');
  gameCode = gameCode.replace(/def play_minigame\(/g, 'async def play_minigam(');
  gameCode = gameCode.replace(/play_minigame\(/g, 'await play_minigame(');
  gameCode = gameCode.replace(/def play_minigam\(/g, 'def play_minigame(');
  gameCode = gameCode.replace(/def ending_stuffs\(/g, 'async def ending_stuf(');
  gameCode = gameCode.replace(/ending_stuffs\(/g, 'await ending_stuffs(');
  gameCode = gameCode.replace(/def ending_stuf\(/g, 'def ending_stuffs(');
  gameCode = gameCode.replace(/def gambling_quit\(/g, 'async def gambling_qui(');
  gameCode = gameCode.replace(/gambling_quit\(/g, 'await gambling_quit(');
  gameCode = gameCode.replace(/def gambling_qui\(/g, 'def gambling_quit(');


  const helpersResp = await fetch(helpersUrl);
  const helpersCode = await helpersResp.text();

  const pythonCode = `${helpersCode}\n${gameCode}`;

  try {
    await pyodide.runPythonAsync(pythonCode);
  } catch (error) {
    customPrint(`Error: ${error}`);
  } finally {
    gameRunning = false;
  }
};
